/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiBroadcastVoxtralSegmentsGet$Params {
  broadcastKey?: string;
  limit?: number;
  scope?: string;
  page?: number;
  size?: number;
  segment_type?: string;
  correction_models?: string;
}

export function apiBroadcastVoxtralSegmentsGet(http: HttpClient, rootUrl: string, params?: ApiBroadcastVoxtralSegmentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralSegmentsGet.PATH, 'get');
  if (params) {
    rb.query('broadcastKey', params.broadcastKey, {});
    rb.query('limit', params.limit, {});
    rb.query('scope', params.scope, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('segment_type', params.segment_type, {});
    rb.query('correction_models', params.correction_models, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralSegmentsGet.PATH = '/api/Broadcast/voxtral-segments';
